import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { Account } from '../entities/account';

@Injectable({ providedIn: 'root' })
export class AccountDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/accounts/current';

    getCurrent(): Observable<Account> {
        return this.http.get<Account>(`${environment.apiUrl}${this.url}`);
    }
}
